import { render, staticRenderFns } from "./EffectManagement.vue?vue&type=template&id=e826e914&scoped=true"
import script from "./EffectManagement.vue?vue&type=script&lang=js"
export * from "./EffectManagement.vue?vue&type=script&lang=js"
import style0 from "./EffectManagement.vue?vue&type=style&index=0&id=e826e914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e826e914",
  null
  
)

export default component.exports